export default {"src":"/_next/static/media/google-play.6695461f.svg","height":40,"width":137,"blurWidth":0,"blurHeight":0};